import React, { ReactNode } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';


interface ReactNodeProps {
  children: ReactNode;
  isDesktopOrLaptop?: any;
}

export const KeenSlider: React.FC<ReactNodeProps> = ({ children, ...props }) => {
  const { isDesktopOrLaptop } = props;
  const [currentSlide, setCurrentSlide] = React.useState(0)
  const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    slideChanged(s) {
      setCurrentSlide(s.details().relativeSlide)
    },
  })

  return (
    <>
      <div className={`relative`}>
        <div ref={sliderRef} className={`keen-slider`}>
          {children}
        </div>
        {slider && (
          <>
            <ArrowLeft
              onClick={(e: any) => e.stopPropagation() || slider.prev()}
              disabled={currentSlide === 0}
              isDesktopOrLaptop={isDesktopOrLaptop}
            />
            <ArrowRight
              onClick={(e: any) => e.stopPropagation() || slider.next()}
              disabled={currentSlide === slider.details().size - 1}
              isDesktopOrLaptop={isDesktopOrLaptop}
            />
          </>
        )}
      </div>
    </>
  )
}

function ArrowLeft(props: any) {
  const { disabeld, isDesktopOrLaptop } = props
  return (
    <div
      onClick={props.onClick}
      className={`
        ${disabeld? `opacity-30` : `cursor-pointer`}
        absolute
        top-1/4
        -mt-15
        lg:mt-0
        lg:top-1/3
        left-0
        transform
        fill-current
        text-white
      `}
    >
      <svg className={`relative`} width="40" height="42" viewBox="0 0 40 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.7" d="M0 0L36 2L40 38L0 42V0Z" fill="#65A3FF"/>
      </svg>
      <svg
        className={`
          absolute
          top-2/4
          left-2/4
          transform
          -translate-y-2/4
          -translate-x-2/4
        `}
        width={isDesktopOrLaptop ? '30' : `26`}
        height={isDesktopOrLaptop ? '17' : `16`}
        viewBox="0 0 36 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1.11612 9.11612C0.627961 9.60427 0.627961 10.3957 1.11612 10.8839L9.07107 18.8388C9.55922 19.327 10.3507 19.327 10.8388 18.8388C11.327 18.3507 11.327 17.5592 10.8388 17.0711L3.76777 10L10.8388 2.92893C11.327 2.44078 11.327 1.64932 10.8388 1.16117C10.3507 0.673011 9.55922 0.673011 9.07107 1.16117L1.11612 9.11612ZM34 11.25L35.25 11.25L35.25 8.75L34 8.75L34 11.25ZM2 11.25L34 11.25L34 8.75L2 8.75L2 11.25Z" />
      </svg>
    </div>
  );
}

function ArrowRight(props: any) {
  const { disabeld, isDesktopOrLaptop } = props
  return (
    <div
      onClick={props.onClick}
      className={`
        ${disabeld? `opacity-30` : `cursor-pointer`}
        absolute
        top-1/4
        -mt-15
        lg:mt-0
        lg:top-1/3
        right-0
        transform
        fill-current
        text-white
      `}
    >
      <svg className={`relative`} width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.7" d="M3 4L38 0V38L0 34L3 4Z" fill="#65A3FF"/>
      </svg>

      <svg
        className={`
          absolute
          top-2/4
          left-2/4
          transform
          -translate-y-2/4
          -translate-x-2/4
        `}
        width={isDesktopOrLaptop ? '30' : `26`}
        height={isDesktopOrLaptop ? '17' : `16`}
        viewBox="0 0 36 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2 8.75L0.75 8.75L0.75 11.25L2 11.25L2 8.75ZM34.8839 10.8839C35.372 10.3957 35.372 9.60427 34.8839 9.11612L26.9289 1.16117C26.4408 0.673012 25.6493 0.673012 25.1612 1.16117C24.673 1.64932 24.673 2.44078 25.1612 2.92893L32.2322 10L25.1612 17.0711C24.673 17.5592 24.673 18.3507 25.1612 18.8388C25.6493 19.327 26.4408 19.327 26.9289 18.8388L34.8839 10.8839ZM2 11.25L34 11.25L34 8.75L2 8.75L2 11.25Z" />
      </svg>
    </div>
  );
}
